import { ModelBase } from '../abstract/model-base.model';

export class ImportBatch extends ModelBase {
    static override CLASS_NAME: string = 'ImportBatch';

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _formatCode!: string;
    private _processingStatus!: string;
    private _rowsError!: number;
    private _rowsIntegrated!: number;
    private _rowsTotal!: number;

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get formatCode(): string {
        return this._formatCode;
    }

    public set formatCode(value: any) {
        this._setValue('_formatCode', value, 'string');
    }

    public get processingStatus(): string {
        return this._processingStatus;
    }

    public set processingStatus(value: any) {
        this._setValue('_processingStatus', value, 'string');
    }

    public get rowsError(): number {
        return this._rowsError;
    }

    public set rowsError(value: any) {
        this._setValue('_rowsError', value, 'integer');
    }

    public get rowsIntegrated(): number {
        return this._rowsIntegrated;
    }

    public set rowsIntegrated(value: any) {
        this._setValue('_rowsIntegrated', value, 'integer');
    }

    public get rowsTotal(): number {
        return this._rowsTotal;
    }

    public set rowsTotal(value: any) {
        this._setValue('_rowsTotal', value, 'integer');
    }
}
